import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 24
}

/**
 * Stateless function representing a icon with devices and a star.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <DeviceImportantIcon width={12} />
 */
const DeviceImportantIcon = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path d="M16.2857 22.2857L14.5714 22.2857L11.1429 22.2857L9.42857 22.2857L9.42857 20.5714L11.1429 20.5714L11.1429 18.8571L5.14286 18.8571C4.2 18.8571 3.42857 18.0857 3.42857 17.1429L3.42857 6.85714C3.42857 5.91429 4.2 5.14286 5.14286 5.14286L20.5714 5.14286C21.5143 5.14286 22.2857 5.91429 22.2857 6.85714L22.2857 11.1429L20.5714 11.1429L20.5714 6.85714L5.14286 6.85714L5.14286 17.1429L16.2857 17.1429L16.2857 18.8571L14.5714 18.8571L14.5714 20.5714L16.2857 20.5714L16.2857 22.2857zM24 13.7143L24 21.4286C24 21.9 23.6143 22.2857 23.1429 22.2857L18.8571 22.2857C18.3857 22.2857 18 21.9 18 21.4286L18 13.7143C18 13.2429 18.3857 12.8571 18.8571 12.8571L23.1429 12.8571C23.6143 12.8571 24 13.2429 24 13.7143zM23.1429 14.5714L18.8571 14.5714L18.8571 20.5714L23.1429 20.5714L23.1429 14.5714zM12.8571 8.57143L12.0257 11.1429L9.42857 11.1429L11.5457 12.6514L10.74 15.1457L12.8571 13.6029L14.9743 15.1457L14.1686 12.6514L16.2857 11.1429L13.7143 11.1429L12.8571 8.57143z" />
    </SvgIcon>
)

DeviceImportantIcon.defaultProps = defaultProps

export { DeviceImportantIcon }
